var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogowarner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 437 292.4",
    style: {
      enableBackground: "new 0 0 437 292.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M278.8,292.4c-21.1-0.9-39.9-11-49.4-33.4c-25.7-60.4-50.8-121.1-75.4-182c-11.8-29.2,2.7-61,31.4-72.7 c27.9-11.4,60.8,1,72.9,29.4c25.8,60.4,51.2,121,75.5,182C348.7,252.9,320.9,292.5,278.8,292.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.1,292.4c-21.2-0.8-40-11-49.6-33.3C53.9,198.6,28.7,137.9,4.1,77C-7.7,47.8,6.8,16,35.5,4.2 c27.9-11.4,60.8,0.9,73,29.3c25.9,60.7,51.5,121.6,75.7,183C198.7,253.3,170.7,292.4,129.1,292.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M373.1,156.7c-21.8-0.7-40.1-11.3-50.4-33.7c-6.9-15-13.1-30.3-18.9-45.7c-11.1-29.5,2.4-60.9,31-72.9 c27.7-11.7,60.1,0.7,73.1,28.7c7.4,15.8,14.2,32,20,48.5C440.9,118.2,414.1,156.4,373.1,156.7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogowarner);
export default __webpack_public_path__ + "static/media/logowarner.4e17c2aa0e6d8cfedf050152b187c511.svg";
export { ForwardRef as ReactComponent };